<ng-container *ngIf="contents.length !== 0">
  <h6 class="mt-2">
    {{section}}
  </h6>
  <div *ngFor="let content of contents">
    <button
      class="content-list-item btn-blank btn-block d-flex justify-content-between"
      [class.item-active]="content.name === this.contentSearch"
      (click)="sendSelectedContent(content)"
      >
      {{content.name}}
      <span class="chip">{{content.valueInCredits}}</span>
    </button>
  </div>
</ng-container>